import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
} from '@angular/core';
import { KYMW00Model } from '../kymw00.model';
import { KYMW0003Model } from './kymw0003.model';
import { PlessDialogServiceSub } from '../pless-dialog-service-sub';
import { PlessViewHelperSub } from '../pless-view-helper-sub';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { GetPlanSupportCompanyInfoService } from './api-services/get-plan-support-company-info.service';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { PlanSupportCompanyInfo } from './vo/PlanSupportCompanyInfoRow';

/**
 * 企画支援選択画面を管理するクラス
 *
 * @export KYMW0003Component
 * @class KYMW0003Component
 */
@Component({
  selector: 'app-kymw0003',
  templateUrl: 'kymw0003.component.html',
  styleUrls: ['kymw0003.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW0003Component extends PlessViewHelperSub implements OnInit {
  public model: KYMW0003Model = new KYMW0003Model();
  @ViewChild('dtg_PlanSupportCompanyInfo', { static: true }) dtg_PlanSupportCompanyInfo: FlexGrid;

  /**
   * Creates an instance of KYMW0003Component.
   *
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetPlanSupportCompanyInfoService} getPlanSupportCompanyInfoService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0003Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getPlanSupportCompanyInfoService: GetPlanSupportCompanyInfoService,
    private kymw00Model: KYMW00Model
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW0003Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0003';

    // 企画支援会社情報取得APIを呼び出す
    this.getPlanSupportCompanyInfoService.execute(this.model);
  }

  /**
   * 設定ボタン押下
   */
  public eventClickHandler_Setting(): void {
    // チェック済みの企画支援会社情報に取引停止区分が1,2のデータが含まれているものの名前を抽出
    const undealedCompanyNames = this.dtg_PlanSupportCompanyInfo.selectedItems
      .filter(_ => ['1', '2'].includes(_.tradeStopDiv))
      .map(_ => _.associatedCompanyName);

    // チェック済みの企画支援会社情報に取引停止区分が1,2のデータが含まれている場合
    if (undealedCompanyNames.length > 0) {
      this.dialogService.openAlertGetMessage('Q0122', [undealedCompanyNames.join(', ')], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          // 「はい」を選択した場合
          // ダイアログを閉じ、呼び出し元画面に企画支援会社情報VO(PlanSupportCompanyInfoVO)を返却する。
          this.model.output = this.dtg_PlanSupportCompanyInfo.selectedItems
            .map(_ =>
              new PlanSupportCompanyInfo(
                _.associatedCompanyId,
                _.associatedCompanyName,
                _.tradeStopDiv,
                _.tradeStopName
              )
            )[0];
          this.onClickClose();
        }
      });
      return;
    }
    // ダイアログを閉じ、呼び出し元画面に企画支援会社情報VO(PlanSupportCompanyInfoVO)を返却する。
    this.model.output = this.dtg_PlanSupportCompanyInfo.selectedItems
      .map(_ =>
        new PlanSupportCompanyInfo(
          _.associatedCompanyId,
          _.associatedCompanyName,
          _.tradeStopDiv,
          _.tradeStopName
        )
      )[0];
    this.onClickClose();
  }

  /**
   * パラメータ取得 呼び出し側から利用
   *
   * @param params
   * @memberof KYMW0003Component
   */
  public getParams(): PlanSupportCompanyInfo {
    return this.model.output;
  }
}
